import React, { useState } from 'react'
import { Card, CardContent, CardHeader, ToggleButton, ToggleButtonGroup } from '@mui/material'
import { DualAxisChart } from '../../../charts/CompositChart'
import { DUAL_AXIS_COLORS } from '../../../charts/colors'
import MaterialTable from '../../../../common/MaterialTable'
import { numberPrecision } from '../../../../helpers/UtilityHelper'

const ReasonAnalysis = ({ data = [] }) => {
    const [view, setView] = useState('chart')

    if (!data || data.length === 0) return null

    const chartOptions = {
        layout: 'horizontal',
        xaxis: 'reason',
        showLabels: true,
        legendAlign: 'left',
        yaxis: {
            left: {
                label: 'Count',
                data: [
                    { dataKey: 'count', label: 'Count', chartType: 'bar', fill: DUAL_AXIS_COLORS.PRIMARY },
                ],
            },
            right: {
                label: 'Percentage',
                data: [
                    { dataKey: 'percentage', unit: '%', label: 'Percentage', chartType: 'bar', fill: DUAL_AXIS_COLORS.SECONDARY },
                ],
            },
        },
    }

    const columns = [
        { label: 'Reason', value: 'reason', align: 'left' },
        { label: 'Count', value: 'count' },
        { label: 'Percentage', value: (row) => `${numberPrecision(row.percentage)}%` },
    ]

    return (
        <Card elevation={1}>
            <CardHeader
                title="Pickup Failure Reasons"
                subheader="Distribution of reasons for pickup failures across all shipments"
                action={
                    <ToggleButtonGroup
                        value={view}
                        exclusive
                        size="small"
                        onChange={(_e, v) => v && setView(v)}
                    >
                        <ToggleButton value="chart">Chart</ToggleButton>
                        <ToggleButton value="table">Table</ToggleButton>
                    </ToggleButtonGroup>
                }
            />
            <CardContent>
                {view === 'chart' ? (
                    <DualAxisChart data={data} chartOptions={chartOptions} />
                ) : (
                    <MaterialTable columns={columns} rows={data} />
                )}
            </CardContent>
        </Card>
    )
}

export default ReasonAnalysis
